import { Empty } from 'antd';
import * as EmailValidator from 'email-validator';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/atoms/button';
import styles from './no-content.module.css';

interface NoContentProps {
  searchText: string;
}

const NoContent: FC<NoContentProps> = ({ searchText = '' }) => {
  if (!searchText) {
    return <Empty />;
  }
  let content = (
    <>
      <div>
        <FormattedMessage id="task.followers.notFound.message" />
      </div>
      <div>
        <FormattedMessage id="task.followers.notFound.description" />
      </div>
    </>
  );

  if (EmailValidator.validate(searchText)) {
    content = (
      <>
        <div>
          <span>
            <strong>{searchText}</strong>
            <FormattedMessage id="task.followers.invite.email" />
          </span>
        </div>
        <div>
          <FormattedMessage id="task.followers.invite.ask" />
        </div>
        <div>
          <Button type="primary">
            <FormattedMessage id="task.followers.invite.confirm" />
          </Button>
        </div>
      </>
    );
  }

  return <div className={styles.wrapper}>{content}</div>;
};

export { NoContent };
